module.exports = __webpack_public_path__ + "img/xiaomi-redmi-note11-pro.175a315d.png";